import { Validator } from '@vista-digital/validator';
import { defaultOrderCartAssets, orderCartAssetsValidator } from './assets';
import { defaultOrderCartCdnOptions, orderCartCdnOptionsValidator } from './cdn-options';
import { defaultOrderCartConfig, orderCartConfigValidator } from './config';
import { defaultOrderCartDisplayText, orderCartDisplayTextValidator } from './display-text';
import { orderCartEventsValidator } from './events';
export const orderCartPropsValidator = Validator.object({
    config: orderCartConfigValidator,
    displayText: orderCartDisplayTextValidator,
    assets: orderCartAssetsValidator,
    events: orderCartEventsValidator,
    cdnOptions: orderCartCdnOptionsValidator
});
export const defaultOrderCartProps = {
    config: defaultOrderCartConfig,
    displayText: defaultOrderCartDisplayText,
    assets: defaultOrderCartAssets,
    events: {},
    cdnOptions: defaultOrderCartCdnOptions
};
